import { render, staticRenderFns } from "./TicketsReplayAttachmentModal.vue?vue&type=template&id=b4fc9b18&scoped=true"
import script from "./TicketsReplayAttachmentModal.vue?vue&type=script&lang=js"
export * from "./TicketsReplayAttachmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fc9b18",
  null
  
)

export default component.exports